module.exports = __webpack_public_path__ + "media/images/favicons/favicon-86fd68af119e6eeadc69f02b9fae0a24.ico";